import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import WithAligners from 'components/common/icons/timelineV2/scan-feed/WithAligners'
import WithoutAligners from 'components/common/icons/timelineV2/scan-feed/WithoutAligners'
import WithAppliance from 'components/common/icons/timelineV2/scan-feed/WithAppliance'
import WithoutAppliance from 'components/common/icons/timelineV2/scan-feed/WithoutAppliance'
import ScanReferralNote from './ScanReferralNote'
import Attachments from 'components/Patients/ShareScan/Attachments'
import { scrollBar } from 'styles/theme'
import useGenericApplianceCopy from 'hooks/useGenericApplianceCopy'

const useStyles = makeStyles(theme => ({
  notificationDestinationLabel: {
    marginTop: 10,
    color: 'var(--text-color-62)'
  },
  sharedByLabel: {
    marginTop: 24
  },
  alignersIcon: {
    lineHeight: 0.8,
    marginRight: 8
  },
  withAlignersContainer: {
    marginTop: 24
  },
  divider: {
    width: '100%',
    height: 1,
    background: 'rgba(206, 208, 212, 1)',
    marginBottom: 16
  },
  withAlignerLabel: {
    fontWeight: 500,
    color: 'var(--text-color-62)'
  },
  referralContent: {
    height: 360,
    overflowY: 'scroll',
    ...scrollBar
  },
  referralReviewContainer: {
    marginTop: 24
  },
  attachmentsLabel: {
    marginBottom: 16
  }
}))

const ScanReferralItem = ({
  referralName,
  referralSpeciality,
  notificationDestination,
  grinDoctorNote,
  referralReview,
  attachments = [],
  withAligner,
  createdAt,
  reviewSubmissionDate,
  createdBy = {}
}) => {
  const useGenericCopy = useGenericApplianceCopy()
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div>
      <Grid container>
        <Grid item xs={4} style={{ paddingRight: 32 }}>
          <DazzedParagraph14 strong>
            {referralName} <div style={{ fontWeight: 400 }}>{referralSpeciality}</div>
          </DazzedParagraph14>
          <DazzedParagraph12 className={classes.notificationDestinationLabel} thickness="strong">
            {notificationDestination}
          </DazzedParagraph12>
          <DazzedParagraph12 className={classes.sharedByLabel} thickness="bold">
            {t('pages.patients.selectedPatient.timelineV2.scanFeed.referrals.sharedBy')}
          </DazzedParagraph12>
          <DazzedParagraph14 strong>
            {createdBy.name}
            <div style={{ fontWeight: 400 }}>{createdBy.roleDescription}</div>
          </DazzedParagraph14>
          {withAligner !== null && (
            <div className={classes.withAlignersContainer}>
              <div className={classes.divider} />
              <Grid container alignItems="center">
                <Grid item className={classes.alignersIcon}>
                  {withAligner ? (
                    useGenericCopy ? (
                      <WithAppliance color="var(--text-color-62)" width="23" height="16" />
                    ) : (
                      <WithAligners color="var(--text-color-62)" size="16" />
                    )
                  ) : useGenericCopy ? (
                    <WithoutAppliance color="var(--text-color-62)" width="23" height="16" />
                  ) : (
                    <WithoutAligners color="var(--text-color-62)" size="16" />
                  )}
                </Grid>
                <Grid item>
                  <DazzedParagraph12 className={classes.withAlignerLabel}>
                    {withAligner
                      ? t(useGenericCopy ? 'general.withAppliance' : 'general.withAligners')
                      : t(useGenericCopy ? 'general.withoutAppliance' : 'general.withoutAligners')}
                  </DazzedParagraph12>
                </Grid>
              </Grid>
            </div>
          )}
        </Grid>
        <Grid item xs={8} className={classes.referralContent}>
          <div>
            <ScanReferralNote
              title={t('pages.patients.selectedPatient.timelineV2.scanFeed.referrals.yourNote')}
              note={grinDoctorNote}
              date={createdAt}
            />
          </div>
          <div className={classes.referralReviewContainer}>
            {referralReview ? (
              <ScanReferralNote
                title={t('pages.patients.selectedPatient.timelineV2.scanFeed.referrals.colleaguesResponse')}
                note={referralReview}
                date={reviewSubmissionDate}
              />
            ) : (
              <DazzedParagraph12 thickness="strong">
                {t('pages.patients.selectedPatient.timelineV2.scanFeed.referrals.notRespondFromColleague')}
              </DazzedParagraph12>
            )}
          </div>
        </Grid>
      </Grid>
      {!!attachments?.length && (
        <div>
          <DazzedParagraph14 bold className={classes.attachmentsLabel}>
            {t('dialogs.viewSharedScan.attachments')}
          </DazzedParagraph14>
          <Attachments files={attachments} editable={false} />
        </div>
      )}
    </div>
  )
}

export default ScanReferralItem
